import api from "../../../services/api";

export const getEcommRevenueOverTime = async () => {
  const { data } = await api.get("/api/shopify/sales_reports/sales_over_time");
  return data;
};

export const getEcommOrdersOverTime = async () => {
  const { data } = await api.get("/api/shopify/sales_reports/orders_over_time");
  return data;
};

export const getEcommUnitsOverTime = async () => {
  const { data } = await api.get("/api/shopify/sales_reports/units_sold_over_time");
  return data;
};
